import React, { memo, useEffect, useMemo, useRef } from 'react';
import PropTypes from 'prop-types';

const removeScripts = (html) => {
    if (!html) return '';
    return html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
};

const ensureHtmlDocument = (html) => {
    if (!html?.trim()) return '';

    const cleanHtml = removeScripts(html);
    const hasHtmlTag = /<html[\s\S]*?>/i.test(cleanHtml);

    if (hasHtmlTag) {
        return cleanHtml;
    }

    return `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
</head>
<body>${cleanHtml}</body>
</html>`;
};

const HtmlPreviewFrame = memo(({ className = '', html, title }) => {
    const iframeRef = useRef(null);

    const documentHtml = useMemo(() => ensureHtmlDocument(html), [html]);

    useEffect(() => {
        if (!iframeRef.current) return;
        iframeRef.current.srcdoc = documentHtml;
    }, [documentHtml]);

    return (
        <iframe
            ref={iframeRef}
            title={title}
            className={className}
            sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin"
        />
    );
});

HtmlPreviewFrame.displayName = 'HtmlPreviewFrame';

HtmlPreviewFrame.propTypes = {
    className: PropTypes.string,
    html: PropTypes.string,
    title: PropTypes.string,
};

export default HtmlPreviewFrame;
